<template>
  <div>
    <div style="position: relative">
      <vs-row vs-w="12" class="mb-4 title">
        <h3
          class="d-inline-block align-self-center uppercase"
          :class="{ h2: !nested, h3: nested }"
        >
          {{ title || '' }}
        </h3>
        <router-link :to="viewMoreUrl" class="d-inline-block">
          <vs-button
            v-if="viewMore"
            color="primary"
            type="border"
            size="small"
            class="d-inline-block ml-5 vertical-align-top"
            >Go to Payment admin</vs-button
          >
        </router-link>
      </vs-row>

      <!-- Testing for Addresses API -->
      <vs-row vs-w="12" class="dashboard-panel">
        <vs-col class="p-0">
          <vs-table
            :max-items="
              maxItemsPerPage
                ? maxItemsPerPage
                : itemsPerPage
                ? itemsPerPage.value
                : 50
            "
            v-model="selectedAddress"
            pagination
            :data="addresses"
            @selected="handleSelectedAddress"
          >
            <template slot="thead">
              <vs-th class="h6">Payment reference</vs-th>
              <vs-th class="h6">Status</vs-th>
              <vs-th class="h6">Creation date</vs-th>
              <vs-th class="h6">Crypto Amount</vs-th>
              <vs-th class="h6">FIAT Amount</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                class="hoverFlat"
              >
                <!-- Address -->
                <vs-td
                  :data="data[indextr].crypto_address"
                  class="no-line-wrap"
                >
                  {{ data[indextr].payment_reference }}
                </vs-td>
                <!--Status-->
                <vs-td
                  :data="data[indextr].payment_tier"
                  class="no-line-wrap status"
                >
                  <span :class="data[indextr].status">{{
                    data[indextr].status
                  }}</span>
                </vs-td>

                <!-- Date -->
                <vs-td
                  :data="data[indextr].last_receive_date"
                  class="no-line-wrap"
                >
                  <div class="xs-show">
                    {{ formatToLocalDate(data[indextr].payment_tier_date) }},
                    {{ formatToLocalTime(data[indextr].payment_tier_date) }}
                  </div>
                </vs-td>

                <!--Cryptocurrency -->
                <vs-td :data="data[indextr].receive_crypto_amount">
                  <!--Check if transaction is under wallet provider (DEPRECATED)-->
                  <!--                    <div v-if="isWallet">-->
                  <!--                      &lt;!&ndash;Check if it is under Binance Pay&ndash;&gt;-->
                  <!--                      <span v-if="data[indextr].payment_tier === 'good' && data[indextr].crypto_currency === 'BINANCE'" >-->
                  <!--                        <span v-if="countDecimals(data[indextr].receive_crypto_amount) > 2">-->
                  <!--                          {{'BTC'}} {{formatCryptoPrice(data[indextr].receive_crypto_amount)}}-->
                  <!--                        </span>-->
                  <!--                        <span v-else>-->
                  <!--                          {{'USDT'}} {{formatFiatPrice(data[indextr].receive_crypto_amount)}}-->
                  <!--                        </span>-->
                  <!--                      </span>-->
                  <!--                    </div>-->

                  <div
                    v-if="
                      !data[indextr].crypto_currency.includes('USDT') &&
                      !data[indextr].crypto_currency.includes('USDC')
                    "
                  >
                    <!--If crypto is sats/lightning-->
                    <div v-if="data[indextr].crypto_currency === 'LNBC'">
                      <span v-if="data[indextr].payment_tier === 'good'"
                        >{{
                          formatFiatPriceNoDigits(
                            data[indextr].receive_crypto_amount
                          )
                        }}
                        {{ data[indextr].display_crypto_currency }}</span
                      >
                      <span v-else
                        >{{
                          formatFiatPriceNoDigits(
                            data[indextr].request_crypto_amount
                          )
                        }}
                        {{ data[indextr].display_crypto_currency }}</span
                      >
                    </div>
                    <!--if payments is under a wallet (eg.Binance pay)-->
                    <div
                      v-else-if="
                        data[indextr].payment_tier === 'good' &&
                        data[indextr].crypto_currency === 'BINANCE'
                      "
                    >
                      <span
                        v-if="
                          countDecimals(data[indextr].receive_crypto_amount) > 2
                        "
                      >
                        {{ 'BTC' }}
                        {{
                          formatCryptoPrice(data[indextr].receive_crypto_amount)
                        }}
                      </span>
                      <span v-else>
                        {{ 'USDT' }}
                        {{
                          formatFiatPrice(data[indextr].receive_crypto_amount)
                        }}
                      </span>
                    </div>
                    <div v-else>
                      <span v-if="data[indextr].payment_tier === 'good'"
                        >{{ data[indextr].display_crypto_currency }}
                        {{
                          formatCryptoPrice(data[indextr].receive_crypto_amount)
                        }}
                      </span>
                      <span v-else>
                        {{ data[indextr].display_crypto_currency }}
                        {{
                          formatCryptoPrice(data[indextr].request_crypto_amount)
                        }}
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="data[indextr].payment_tier === 'good'"
                      >{{ data[indextr].display_crypto_currency }}
                      {{
                        formatFiatPrice(data[indextr].receive_crypto_amount)
                      }}</span
                    >
                    <span v-else
                      >{{ data[indextr].display_crypto_currency }}
                      {{
                        formatFiatPrice(data[indextr].request_crypto_amount)
                      }}</span
                    >
                  </div>
                </vs-td>

                <!--Local Currency -->
                <vs-td>
                  <!--                   <span v-if="data[indextr].payment_tier.indexOf('good') === 0"> {{data[indextr].local_currency}} {{ formatFiatPrice(data[indextr].request_local_amount) }}</span>-->
                  <!--                   <span v-else> {{data[indextr].local_currency}} {{ formatFiatPrice(data[indextr].request_crypto_amount * data[indextr].rate) }}</span>-->
                  <span>
                    {{ data[indextr].local_currency }}
                    {{
                      formatFiatPrice(data[indextr].request_local_amount)
                    }}</span
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
    </div>

    <!-- <triplea-tx-popup
      :transaction="selected"
      :debug-transaction="debugTransactions"
      :local-currency="localCurrency"
      :display-counter="popupDisplayCounter"
      :disableRefunds="disableRefunds"
    ></triplea-tx-popup>-->

    <pre v-if="debugSelected">{{ selected }}</pre>
    <div v-if="debugTransactions">
      <strong>Debugging: showing first 3 transactions</strong>
      <br />
      <pre>{{ transactions ? transactions.slice(0, 3) : 'no tx!' }}</pre>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
// import {Parser} from 'json2csv';
// import {saveAs} from 'file-saver';

import TripleaTxPopup from '../triplea-tx-popup/TripleaTxPopup';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    'v-select': vSelect,
    TripleaTxPopup,
  },
  props: {
    addresses: Array,
    transactions: Array,
    title: String,
    debugTransactions: Boolean,
    debugSelected: Boolean,
    localCurrency: String,
    maxItemsPerPage: {
      type: Number,
      default: null,
    },
    hidePager: {
      type: Boolean,
      default: false,
    },
    disableRefunds: {
      type: Boolean,
      default: false,
    },
    viewMore: {
      type: Boolean,
      default: false,
    },
    viewMoreUrl: {
      type: String,
      default: '',
    },
    exportOptions: {
      type: Boolean,
      default: true,
    },
    nested: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeExportPrompt: false,
      daysToDisplay: 60,
      // filteredTransactions: this.filterTx(this.transactions),
      selected: null,
      selectedAddress: null,
      itemsPerPageOptions: [
        {
          label: '5',
          value: 5,
        },
        {
          label: '10',
          value: 10,
        },
        {
          label: '15',
          value: 15,
        },
        {
          label: '20',
          value: 20,
        },
        {
          label: '50',
          value: 50,
        },
      ],
      itemsPerPage: 50,
      txIdForPopup: null,
      // When a same row is clicked after already being selected,
      // we increment this number to trigger re-displaying of popup.
      // popupDisplayCounter: 0
    };
  },
  mounted() {
    this.itemsPerPage = this.itemsPerPageOptions[4];
  },
  beforeDestroy() {
    this.fetchAddressesAction().then((results) => {
      if (this.debugConsole)
        console.debug('fetchAddressesAction done', results);
    });

    this.fetchAddressesCountAction({ daysToDisplay: this.daysToDisplay }).then(
      (results) => {
        if (this.debugConsole) {
          console.debug('fetchAddressesCountsAction done', results);
        }   
      }
    );
  },
  computed: {
    ...mapGetters(['activeAccountGetter']),
    filteredTransactions() {
      //return this.filterTx(this.transactions).reverse();
      return this.filterTx(this.transactions).sort(function (a, b) {
        return b.blocktime - a.blocktime;
      });
    },
    //check if it is a wallet provider from the currency length
    isWallet() {
      if (
        this.activeAccountGetter &&
        this.activeAccountGetter.cryptoCurrency.length > 4 &&
        this.activeAccountGetter.cryptoCurrency !== 'testBTC' &&
        !this.activeAccountGetter.cryptoCurrency.includes('_')
      ) {
        return true;
      } else {
        return false;
      }
    },

    isNetwork() {
      if (
        this.activeAccountGetter &&
        this.activeAccountGetter.cryptoCurrency.includes('_')
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions(['fetchAddressesAction', 'fetchAddressesCountAction']),

    doExport() {
      this.logAction('accept');
      console.log('do Export function called');

      // check if debit transactions should be included
      // check if unconfirmed transactions should be included
      // check what fields should be included

      /**
       * Generate CSV file from data in table.
       *
       * Allow users to check which extra fields to include,
       * choose amongst a few optional fields.
       * - decide what field titles to add,
       * - decide what properties to set on objet during .map().
       */

      // 1 status from confirmation
      // 2 client tracking id from client_txid
      // 3 bitcoin value
      // 4 "XYZ" column TITLE: from local_currency
      //   and "XYZ" column Value: from value*rate
      // 5 Exchange rate from rate
      // 6 Exchange rate time from rate_datetime
      // 7 Locked rate from locked_rate_expired
      // 8 Transaction created time from created (if present)
      // 9 Transaction validation time (1st confirmation) from blocktime
      // 10 Blockchain explorer link from txid

      if (!this.localCurrency || this.localCurrency.length < 3) {
        console.warn('LOCAL CURRENCY NOT DEFINED');
      }

      const fields = [
        {
          label: 'Status', // Optional, column will be labeled 'path.to.something' if not defined)
          value: 'status',
          default: 'NULL',
        },
        {
          label: 'Client tracking ID',
          value: 'client_txid',
          default: 'NULL',
        },
        {
          label: 'Bitcoin',
          value: 'crypto_amount',
          default: 'NULL',
        },
        {
          label: this.localCurrency || 'Local currency',
          value: 'currency_amount',
          default: 'NULL',
        },
        {
          label: 'XR',
          value: 'rate',
          default: 'NULL',
        },
        {
          label: 'XR time',
          value: 'rate_datetime',
          default: 'NULL',
        },
        {
          label: 'Locked rate',
          value: 'locked_rate_expired',
          default: 'NULL',
        },
        {
          label: 'Tx date', // date created
          value: 'created',
          default: 'NULL',
        },
        {
          label: 'Tx validated',
          value: 'validated', // custom property during .map()
          default: 'NULL',
        },
        {
          label: 'Tx details',
          value: 'tx_details_url', // custom property during .map()
          default: 'NULL',
        },

        // 'Status',
        // 'Client tracking ID',
        // 'Bitcoin',
        // this.localCurrency,
        // 'XR',
        // 'XR date',
        // 'Locked rate',
        // 'Tx created',
        // 'Tx validated',
        // 'Tx details'
      ];
      const opts = { fields };

      // TODO .filter() object then transform remaining rows using .map()

      let jsonTransactions = this.filteredTransactions.map((tx) => {
        let newTx = {
          status: tx.confirmation > 0 ? 'confirmed' : 'unconfirmed',
          client_txid: tx.client_txid,
          crypto_amount: this.formatCryptoPrice(tx.value),
          currency_amount: this.formatFiatPrice(tx.value * tx.rate),
          rate: tx.rate.toFixed(4),
          rate_datetime: this.getDateShort(tx.rate_datetime),
          locked_rate_expired: tx.locked_rate_expired ? 'true' : 'false',
          created: tx.created
            ? this.getDateShort(tx.created)
            : tx.created.replace('T', ' ').split('.')[0],
          validated: this.getDateShort(tx.blocktime),
          tx_details_url: tx.txid
            ? 'https://www.blockchain.com/btc/tx/' + tx.txid
            : '',
        };
        return newTx;
      });

      let saveAsFilename = 'transactions-triplea.csv';
      this.downloadJsonAsCsv(opts, jsonTransactions, saveAsFilename);
    },
    logAction(text) {
      console.warn('logAction(): ' + text);
    },
    formatTxTableTime(timeString) {
      let options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      };
      let formattedDate = new Date(timeString.split(' ')[0]).toLocaleString(
        'en-us',
        options
      );
      return formattedDate;
    },
    formatTxTableHourandMinute(timeString) {
      let formattedHourandMinute = timeString.split(' ')[1].split('.')[0];
      return formattedHourandMinute;
    },
    txStatus(tx) {
      if (tx.confirmation && tx.confirmation > 0) {
        return 'Confirmed';
      }
      return 'Unconfirmed';
    },
    // eslint-disable-next-line no-unused-vars
    // handleSelected(tr) {
    //   // this.$store.commit('TOGGLE_DISPLAY_POPUP', true)
    //   this.$store.commit("UPDATE_SELECTED_TRANSACTION", this.selected);
    //   this.$store.commit("UPDATE_POPUP_DISPLAY_COUNTER");
    //   // this.popupDisplayCounter += 1;
    //   this.$store.dispatch(
    //     "fetchMoreTransactionInfoAction",
    //     this.selected.address
    //   );
    //   // this.$vs.notify({
    //   //   title:`Selected ${tr.username}`,
    //   //   text:`Email: ${tr.email}`
    //   // })
    // },
    handleSelectedAddress(tr) {
      this.$router.push('payments');
      // this.$store.commit("UPDATE_SELECTED_ADDRESS", this.selectedAddress);
      // this.$store.commit('UPDATE_POPUP_DISPLAY_COUNTER');
      // // this.$store.dispatch('fetchMoreAddressInfoAction', this.selectedAddress.crypto_address)
      // this.$store.dispatch('fetchMoreAddressInfoAction', this.selectedAddress.payment_reference)
    },

    countDecimals(value) {
      if (Math.floor(value) === value) return 0;
      return value.toString().split('.')[1].length || 0;
    },
  },
};
</script>

<style scoped lang="scss">
input[type='date'] {
  height: 30px;
  border-radius: 5px;
  padding: 3px;
  border: 0.5px solid lightgrey;
}
.title {
  flex-wrap: nowrap;
}

.tr-expand td .content-tr-expand,
.tr-expand td .tr-expand--close {
  justify-content: normal;
}

.contain-expand-tx {
  width: 100%;
}

tr.tr-expand {
  box-shadow: inset rgba(0, 0, 0, 0.15) 0px 4px 6px;
}

.lh-30 {
  line-height: 30px;
}

.items-per-page-container {
  position: absolute;
  bottom: 10px;
  zoom: 0.85;
  margin-left: 10px;
}

@media (max-width: 800px) {
  .items-per-page-container {
    position: relative;
    zoom: 0.85;
    margin-left: auto;
    display: block;
    width: fit-content;
    margin-top: 20px;
  }
}

.items-per-page-select {
  width: 100px;
  display: inline-block;
}

.prompt {
  padding: 10px 10px 0;
}

.col-text-right {
  text-align: right;
}

.col-text-right div {
  display: inline-block;
}

.vertical-align-top {
  vertical-align: top;
}

.vs-table--tbody-table tr {
  border-top: 1px solid lightgray;
  font-size: 16px;
}

.vs-table--tbody-table thead tr {
  border: none;
  background: unset;
}

.vs-table--tbody-table .tr-values.hoverFlat {
  transition: none;
}

.vs-table--tbody-table
  .tr-values.hoverFlat:not(.activeEdit):not(.is-expand):hover {
  opacity: 0.8;
  background: #eee;
  transition: none;
}

.transactionId {
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.capitalize {
  text-transform: capitalize;
}

.con-pagination-table.vs-table--pagination {
  display: none;
}
/* .con-pagination-table.vs-table--pagination {
    display: block;
} */

.status span {
  text-transform: capitalize;
  padding: 3px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  &.good {
    background-color: green;
    color: white;
  }
  &.short {
    background-color: white;
    border-color: orange;
    color: orange;
  }
  &.invalid {
    background-color: #8c2222;
    color: white;
  }
  &.hold {
    background-color: orange;
  }
  &.none {
    background-color: grey;
    color: white;
  }
}
</style>
